"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
// import _debounce from "lodash/debounce";

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization;
var LazyNavBackgroundImage = function LazyNavBackgroundImage(_ref) {
  var backgroundImage = _ref.backgroundImage;
  var innerWidth = 360;
  if (typeof window !== 'undefined') {
    innerWidth = window.innerWidth;
  }
  var apply = function apply() {
    var resultHTML = '';
    var breakpoint = 768;
    var imageWidth = 1080;
    var imageSrc = handleNestedProp(backgroundImage, 'backgroundImage.image');
    var isBackground = false;
    var isWebp = true;
    var imageQuality = 70;
    if (innerWidth === undefined || innerWidth < breakpoint) {
      resultHTML = '';
    } else {
      resultHTML = /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
        className: _navigationHeader["default"].panelBackground,
        src: appendImageOptimization(imageSrc, imageWidth, isBackground, isWebp, imageQuality),
        srcSet: [appendImageOptimization(imageSrc, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(imageSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imageSrc, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(imageSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imageSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imageSrc, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(','),
        alt: "nav_background"
      });
    }
    return resultHTML;
  };

  // return (_debounce(apply, 300, {'leading': true, 'trailing': true}));
  return apply();
};
var _default = exports["default"] = LazyNavBackgroundImage;